export default __webpack_public_path__ + "static/media/atomic-design-3.85025e8d.webp";